
import { CampaignItems } from '../CampaignItems';

export class CampaignItemsAdvertiser extends CampaignItems {

  constructor(props) {
    super(props, {pageForOrgType: 'ADVERTISER'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/advertisers/CampaignItemsAdvertiser.js